import { render, staticRenderFns } from "./LotDetail.vue?vue&type=template&id=8650ed60&"
import script from "./LotDetail.vue?vue&type=script&lang=js&"
export * from "./LotDetail.vue?vue&type=script&lang=js&"
import style0 from "./LotDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8650ed60')) {
      api.createRecord('8650ed60', component.options)
    } else {
      api.reload('8650ed60', component.options)
    }
    module.hot.accept("./LotDetail.vue?vue&type=template&id=8650ed60&", function () {
      api.rerender('8650ed60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/provisionsRisques/components/LotDetail.vue"
export default component.exports